import React, { useState } from 'react'

interface CollapsibleSectionProps {
  title: string
  icon?: string
  defaultExpanded?: boolean
  children: React.ReactNode
  badge?: string | number
}

const CollapsibleSection: React.FC<CollapsibleSectionProps> = ({
  title,
  icon,
  defaultExpanded = false,
  children,
  badge,
}) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded)

  return (
    <section className="panel-section">
      <div
        className="xp-section-header cursor-pointer select-none"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <div className="flex items-center gap-2 min-w-0">
          {icon && (
            <span className="xp-badge shrink-0">
              {icon}
            </span>
          )}
          <h3 className="panel-title truncate">{title}</h3>
          {badge !== undefined && (
            <span className="xp-badge shrink-0">{badge}</span>
          )}
        </div>
        <button
          type="button"
          className="xp-btn xp-btn-small min-w-[24px]"
          aria-label={isExpanded ? `收起${title}` : `展开${title}`}
        >
          {isExpanded ? '-' : '+'}
        </button>
      </div>

      {isExpanded && (
        <div className="xp-section-body">
          {children}
        </div>
      )}
    </section>
  )
}

export default CollapsibleSection
